import { OrganizationDetailWrapper } from '$features/organizations/detail';

export function OrganizationDetailPage() {
  return <OrganizationDetailWrapper />;
}
